import styled from 'styled-components';

export const ProductListingContainerWithFilters = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ProductListingContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
  ${({ theme }) => theme.breakpoints.down('xl')} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    padding: 1% 0%;
  }
  position: relative;
`;

export const AppliedFiltersContainer = styled.div`
  margin-bottom: 10px;
  display: flex;
  width: fit-content;
  row-gap: 5px;
  flex-wrap: wrap;
  align-items: center;
`;

export const AppliedFilterItem = styled.div`
  padding: 8px;
  margin-right: 10px;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.9rem;
  border: 0.1px solid rgba(0, 0, 0, 0.14);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
  color: rgba(0, 0, 0, 0.73);
  &:hover {
    color: rgba(0, 0, 0, 0.14);
    text-decoration: line-through;
    cursor: pointer;
    border: 0px;
  }
`;

export const AppliedFilterName = styled.div`
  margin-right: 6px;
  font-weight: 00;
`;

export const AppliedFilterValue = styled.div``;

export const ProductListingLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10%;
`;

export const FetchMoreSection = styled.div`
  position: absolute;
  padding: 10px;
  bottom: 1000px;
  left: 0;
  right: 0;
`;

export const Overlay = styled.div<{ isFetching: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  backdrop-filter: ${({ isFetching }) => (isFetching ? 'blur(3px)' : 'none')};
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FetchMoreLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ReloadMessageContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  text-align: center;
`;

export const ReloadMessage = styled.div`
  width: 30%;
  margin-top: 10%;
  padding: 0px 10px 10px 10px;
  border: 1px solid rgba(0, 0, 0, 0.13);
`;

export const NoProductsFound = styled.div`
  padding: 25px;
`;

export const ClearAll = styled.div`
  cursor: pointer;
  color: rgba(32, 154, 214, 1);
  font-size: 0.8rem;
  font-weight: 500;
  padding: 2px;
  &:hover {
    color: rgba(2, 119, 180, 1);
  }
`;
